<template>
  <div class="post-player">
    <video
      class="video"
      ref="video"
      playsinline
      controls
      :poster="poster"
      style="width: 100%"
    ></video>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import Plyr from 'plyr';
import Hls from 'hls.js';

export default defineComponent({
  name: 'PostPlayer',

  /**
   * 属性
   */
  props: {
    post: {
      type: Object,
    },
  },

  /**
   * 数据
   */
  data() {
    return {
      currentTime: 0,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      _post: 'post/show/post',
      poster: 'post/player/poster',
      qualityOptions: 'post/player/qualityOptions',
      currentQuality: 'post/player/currentQuality',
      controls: 'post/player/controls',
      hideControls: 'post/player/hideControls',
      seekTime: 'post/player/seekTime',
      i18n: 'post/player/i18n',
      currentStream: 'post/player/currentStream',
      player: 'post/player/player',
    }),
  },

  watch: {
    post(newValue) {
      if (newValue) {
        this.loadStream();
      }
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 已挂载
   */
  mounted() {
    // 切换播放器
    this.createPlayer();

    // 加载 stream
    this.loadStream();
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentQuality: 'post/player/setCurrentQuality',
      setPlayer: 'post/player/setPlayer',
    }),

    createPlayer() {
      // 播放器选项
      const playerOptions = {
        quality: {
          default: this.currentQuality,
          options: this.qualityOptions,
          forced: true,
          onChange() {
            // console.log('change');
          },
        },
        seekTime: this.seekTime,
        hideControls: this.hideControls,
        i18n: this.i18n,
        controls: this.controls,
        keyboard: {
          global: true,
        },
      };

      // 创建播放器
      const player = new Plyr(this.$refs.video, playerOptions);
      window.player = player;
      this.setPlayer(player);

      // 监听事件
      this.playerListener();
    },

    loadStream() {
      if (Hls.isSupported()) {
        if (window.hls) {
          // 切换 stream 的时候需要先 destroy
          window.hls.destroy();
        }

        const hlsOptions = {
          maxBufferLength: 10,
        };

        // 创建 Hls
        window.hls = new Hls(hlsOptions);

        // 载入源
        window.hls.loadSource(this.currentStream.FileUrl);
        window.hls.attachMedia(this.$refs.video);

        // 监听事件
        this.hlsListener();
      }
    },

    hlsListener() {
      // 监听
      window.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
        window.player.poster = this.poster;

        window.player.currentTime = this.currentTime;
        this.currentTime = 0;
      });
    },

    playerListener() {
      window.player.on('qualitychange', event => {
        const { quality } = event.detail;

        if (quality && this.currentQuality !== quality) {
          this.currentTime = window.player.currentTime;
          this.setCurrentQuality(event.detail.quality);
          this.loadStream();
        }
      });
    },
  },

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/plyr.css';
@import './styles/post-player.css';
</style>
